import React, { useMemo, useState, useCallback, useContext } from 'react';

import { LocalizationContext } from 'app/localization/Context';

import Picker from './TouchPicker';

import "./TimePicker.scss"

export const TimePickerType = {
    minute_second: 0,
    hour_minute: 1,
};

export default function TimePicker(
    {
        type,
        height, eachPickerWidth,
        pickerName,
        baseFontSize,
        timeSelectedCallback,
        defaultHours, defaultMinutes, defaultseconds,
        className, style, color,
    }
) {
    const localizeNumber = useContext(LocalizationContext).localizeNumber;

    const secondItems = useMemo(() => getSecondItems(localizeNumber), [localizeNumber]);
    const minuteItems = useMemo(() => getMinuteItems(localizeNumber), [localizeNumber]);
    const hourItems = useMemo(() => getHourItems(localizeNumber), [localizeNumber]);

    const [hours, setHours] = useState(defaultHours);
    const [minutes, setMinutes] = useState(defaultMinutes);
    const [seconds, setSeconds] = useState(defaultseconds);

    const addedClassName = className ? className : "";
    const addedStyle = style ? style : {};
    const _color = color ? color : "#454545";

    const hoursChangedCallback = useCallback((h) => {
        if (h !== hours) {
            setHours(h);
            if (timeSelectedCallback && typeof (timeSelectedCallback) === 'function')
                timeSelectedCallback(h, minutes, seconds);
        }
    }, [hours, minutes, seconds, timeSelectedCallback]);
    const minutesChangedCallback = useCallback((m) => {
        if (m !== minutes) {
            setMinutes(m);
            if (timeSelectedCallback && typeof (timeSelectedCallback) === 'function')
                timeSelectedCallback(hours, m, seconds);
        }
    }, [hours, minutes, seconds, timeSelectedCallback]);
    const secondsChangedCallback = useCallback((s) => {
        if (s !== seconds) {
            setSeconds(s);
            if (timeSelectedCallback && typeof (timeSelectedCallback) === 'function')
                timeSelectedCallback(hours, minutes, s);
        }
    }, [hours, minutes, seconds, timeSelectedCallback]);

    if (type === TimePickerType.minute_second) {
        return (
            <div className={"time-picker-container " + addedClassName} style={addedStyle} dir="ltr">
                <Picker
                    style={{ justifyItems: "right" }}
                    height={height} width={eachPickerWidth} color={_color}
                    baseFontSize={baseFontSize} minScale={0.5} minOpacity={0.3}
                    items={minuteItems} defaultSelectedIndex={defaultMinutes}
                    indexSelectedCallback={minutesChangedCallback}
                    pickerName={pickerName + "_p1"} />
                <div className="time-picker-delimiter" style={{ color: _color, fontSize: baseFontSize }}>:</div>
                <Picker
                    style={{ justifyItems: "left" }}
                    height={height} width={eachPickerWidth} color={_color}
                    baseFontSize={baseFontSize} minScale={0.5} minOpacity={0.3}
                    items={secondItems} defaultSelectedIndex={defaultseconds}
                    indexSelectedCallback={secondsChangedCallback}
                    pickerName={pickerName + "_p2"} />
            </div>
        )
    } else if (type === TimePickerType.hour_minute) {
        return (
            <div className={"time-picker-container " + addedClassName} style={addedStyle} dir="ltr">
                <Picker
                    style={{ justifyItems: "right" }}
                    height={height} width={eachPickerWidth} color={_color}
                    baseFontSize={baseFontSize} minScale={0.5} minOpacity={0.3}
                    items={hourItems} defaultSelectedIndex={defaultHours}
                    indexSelectedCallback={hoursChangedCallback}
                    pickerName={pickerName + "_p1"} />
                <div className="time-picker-delimiter" style={{ color: _color, fontSize: baseFontSize }}>:</div>
                <Picker
                    style={{ justifyItems: "left" }}
                    height={height} width={eachPickerWidth} color={_color}
                    baseFontSize={baseFontSize} minScale={0.5} minOpacity={0.3}
                    items={minuteItems} defaultSelectedIndex={defaultMinutes}
                    indexSelectedCallback={minutesChangedCallback}
                    pickerName={pickerName + "_p2"} />
            </div>
        )
    }
}

function getSecondItems(localizeNumber) {
    const secondMark = <div style={{ fontSize: "60%" }}>″</div>;
    let items = [];
    for (let i = 0; i < 10; i++) {
        items.push(<div className="time-picker-item"><div>{localizeNumber("0" + String(i))}</div>{secondMark}</div>);
    }
    for (let i = 10; i < 60; i++) {
        items.push(<div className="time-picker-item"><div>{localizeNumber(String(i))}</div>{secondMark}</div>);
    }
    return items;
}

function getMinuteItems(localizeNumber) {
    const minuteMark = <div style={{ fontSize: "60%" }}>′</div>;
    let items = [];
    for (let i = 0; i < 10; i++) {
        items.push(<div className="time-picker-item"><div>{localizeNumber("0" + String(i))}</div>{minuteMark}</div>);
    }
    for (let i = 10; i < 60; i++) {
        items.push(<div className="time-picker-item"><div>{localizeNumber(String(i))}</div>{minuteMark}</div>);
    }
    return items;
}

function getHourItems(localizeNumber) {
    let items = [];
    for (let i = 0; i < 10; i++) {
        items.push(localizeNumber("0" + String(i)));
    }
    for (let i = 10; i < 24; i++) {
        items.push(localizeNumber(String(i)));
    }
    return items;
}